// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Stack, Typography } from '@mui/material';

const EnergyTreeNodeDetailSummary = ({ node }) => {
  const { t } = useTranslation('energyxplorer');

  const isResidual =
    node?.options !== null &&
    node?.options?.specialNodeType !== null &&
    node?.options?.specialNodeType !== 0;

  return (
    <Stack spacing={1}>
      {node?.dataStreams?.length === 0 && !isResidual && (
        <Typography variant="body2">
          {t('nodes.detail_summary.this_node_is')}{' '}
          <b>
            <u>{t('nodes.detail_summary.virtual_node')}</u>
          </b>
          {t('nodes.detail_summary.virtual_description')}
        </Typography>
      )}

      {node?.dataStreams?.length === 0 && isResidual && (
        <Typography variant="body2">
          {node?.options?.specialNodeType === 'FlatResidual' && (
            <>
              {t('nodes.detail_summary.this_node_is')}{' '}
              <u>
                <b>{t('nodes.detail_summary.flat_residual')}</b>
              </u>
              {t('nodes.detail_summary.flat_residual_description')}
            </>
          )}

          {node?.options?.specialNodeType === 'PercentageResidual' && (
            <>
              {t('nodes.detail_summary.this_node_is')}{' '}
              <u>
                <b>{t('nodes.detail_summary.percent_residual')}</b>
              </u>
              {t('nodes.detail_summary.percent_residual_description')}
            </>
          )}

          {node?.options?.specialNodeType === 'RestResidual' && (
            <>
              {t('nodes.detail_summary.this_node_is')}{' '}
              <u>
                <b>{t('nodes.detail_summary.rest_residual')}</b>
              </u>
              {t('nodes.detail_summary.rest_residual_description')}
            </>
          )}
        </Typography>
      )}
    </Stack>
  );
};

export default EnergyTreeNodeDetailSummary;
